module.exports = __webpack_public_path__ + "static/media/brenthaven.f7eb81b5.svg";